// Copyright (c) 2019 Verimatrix, Inc.  All Rights Reserved.

import {createHashHistory} from 'history'

export default createHashHistory()
